'use client'

import React from 'react'
import { useLanguage, type Language } from '@/context/LanguageContext'
import { cn } from '@/lib/utils'
import { Icons } from '@/components/ui/icons'
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu'

export function LanguageSelector() {
  const { language, setLanguage, t } = useLanguage()

  const languageLabels: Record<Language, string> = {
    en: 'English',
    hi: 'हिन्दी (Hindi)',
    mr: 'मराठी (Marathi)',
  }

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button
          className={cn(
            'flex h-9 items-center gap-2 px-3 rounded-full border border-border/50 bg-white/50 text-sm text-brand-navy font-medium',
            'transition-all duration-300 ease-out',
            'hover:border-brand-cornflower/40 hover:bg-white/90 hover:shadow-sm',
            'focus:outline-none focus:ring-2 focus:ring-brand-cornflower/50'
          )}
          aria-label={t('nav.select_lang')}
        >
          <Icons.globe className='h-4 w-4 text-brand-cornflower' strokeWidth={1.5} />
          <span className='hidden sm:inline'>{languageLabels[language]}</span>
          <Icons.chevronDown className='h-4 w-4 opacity-50' strokeWidth={1.5} />
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align='end' className='w-48'>
        {(['en', 'hi', 'mr'] as Language[]).map((lang) => (
          <DropdownMenuItem
            key={lang}
            onClick={() => setLanguage(lang)}
            className={cn(
              'flex items-center justify-between rounded-lg px-3 py-2.5 text-sm font-medium',
              language === lang
                ? 'bg-brand-cornflower/10 text-brand-navy font-semibold'
                : 'text-gray-700'
            )}
          >
            <span>{languageLabels[lang]}</span>
            {language === lang && (
              <Icons.check className='h-4 w-4 text-brand-cornflower' strokeWidth={2.5} />
            )}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  )
}
